import { useEffect } from 'react'

export function useRequestProfileListUnreadSync({
  isEnabled,
  requestId,
  unread,
  onSyncListItemUnread,
}) {
  useEffect(() => {
    if (isEnabled) {
      onSyncListItemUnread?.(requestId, unread)
    }
  }, [isEnabled, unread])
}
